import React from 'react';
import { Row, Col, Card } from 'antd';
import { ExtraInfo } from '../../attribution/components';
// Global Styles
import {
  KPITitleText,
  KpiSubText,
} from '../../../../../../../platform/shared/globalStyling/styledText';

import {
  formatCurrency2SigFig,
  formatWholeNumberNaN,
} from '../../../../../../../core/utils/campaigns';

const styles = {
  title: {
    marginBottom: '10px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
};

const DetailBar = ({ data = { transactions: 0, revenue: 0, quantity: 0 } }) => {
  return (
    <Row>
      <Col flex={4}>
        <Card style={{ height: '10em' }} bodyStyle={{ borderLeft: 0, borderRight: 0 }}>
          <div style={styles.title}>
            <KPITitleText text="Transactions" />
          </div>
          <KpiSubText text={formatWholeNumberNaN(data.transactions)} />
        </Card>
      </Col>
      <Col flex={4}>
        <Card style={{ height: '10em', borderLeft: 0 }} bodyStyle={{ borderLeft: 0 }}>
          <div style={styles.title}>
            <KPITitleText text="Sub Total" />
            <ExtraInfo title="Revenue before taxes, shipping and promotions" placement="top" />
          </div>
          <KpiSubText text={`${formatCurrency2SigFig(data.revenue)}`} />
        </Card>
      </Col>
      <Col flex={4}>
        <Card style={{ height: '10em', borderLeft: 0 }} bodyStyle={{ borderLeft: 0 }}>
          <div style={styles.title}>
            <KPITitleText text="Quantity" />
            <ExtraInfo
              title="Total number of product items within all selected transactions"
              placement="top"
            />
          </div>
          <KpiSubText text={formatWholeNumberNaN(data.quantity)} />
        </Card>
      </Col>
    </Row>
  );
};

export default DetailBar;
